export default __webpack_public_path__ + "static/worldline-large-f885d6a06a14dd38739b52381978842c.png";